let lockCount = 0;
let savedBodyOverflow = "";
let savedBodyPaddingRight = "";
let savedNavbarPaddingRight = "";

function getScrollbarWidth() {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

function getNavbar() {
  return document.getElementById("navbar");
}

export function lockBodyScroll() {
  if (lockCount === 0) {
    const scrollbarWidth = getScrollbarWidth();

    savedBodyOverflow = document.body.style.overflow;
    savedBodyPaddingRight = document.body.style.paddingRight;

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    const navbar = getNavbar();
    if (navbar) {
      savedNavbarPaddingRight = navbar.style.paddingRight;
      if (scrollbarWidth > 0) {
        navbar.style.paddingRight = `${scrollbarWidth}px`;
      }
    }
  }

  lockCount += 1;
}

export function unlockBodyScroll() {
  if (lockCount === 0) return;

  lockCount -= 1;
  if (lockCount > 0) return;

  document.body.style.overflow = savedBodyOverflow;
  document.body.style.paddingRight = savedBodyPaddingRight;

  const navbar = getNavbar();
  if (navbar) {
    navbar.style.paddingRight = savedNavbarPaddingRight;
  }
}
